import useSellerInsuranceProviders from './use-seller-insurance-providers';

const useSellerInsuranceProvider = (sellerInsuranceProviderId) => {
  const sellerInsuranceProviders = useSellerInsuranceProviders();

  return sellerInsuranceProviders.find((sellerInsuranceProvider) => {
    return sellerInsuranceProvider.sellerInsuranceProviderId === sellerInsuranceProviderId;
  });
};

export default useSellerInsuranceProvider;
